import { Box, Link } from "@mui/material";
import MaterialTable from "material-table";
import React, { useState } from "react";
import ReviewForm from "../ReviewForm";
import { ConvertDate } from "../../../../Base/helper/baseFunctions";

const ActionRequiredTR = () => {
    const [openReviewForm, setOpenReviewForm] = useState(false);
    const [currentStage, setCurrentStage] = useState(0);
    const [selectedReviewYear, setSelectedReviewYear] = useState({})
  return (
    <Box pt={1.5}>
     { !openReviewForm ? (
      <MaterialTable
        columns={[
          {
            title: "Title",
            field: "title",
            render: (rowData) => (
              <Link
                href="#"
                underline="hover"
                color="primary"
                onClick={(e) => {
                  e.preventDefault();
                  // 👇 Handle click event here
                  setOpenReviewForm(true);
                  setCurrentStage(rowData?.currentStep)
                  setSelectedReviewYear(rowData);
                }}
              >
                {rowData.title}
              </Link>
            ),
          },
          { title: "Employee", field: "employee" },
          { title: "Status", field: "status" },
          { title: "Completed On", field: "completedOn", render: (rowData) => ConvertDate(rowData?.completedOn) },
        ]}
        data={reviewData}
        options={{
          maxBodyHeight: "calc(100vh - 280px)",
          minBodyHeight: "calc(100vh - 280px)",
          rowStyle: {
            fontSize: "13px",
            height: "35px",
          },
          cellStyle: {
            padding: "5px 0px 5px 13px",
          },
          headerStyle: {
            padding: "5px 10px 5px 10px",
            fontWeight: "bold",
          },
          sorting: true,
          search: true,
          searchText: "",
          searchFieldAlignment: "right",
          searchAutoFocus: false,
          searchFieldVariant: "standard",
          filtering: false,
          paging: true,
          pageSizeOptions: [25, 50],
          pageSize: 25,
          paginationType: "stepped",
          showFirstLastPageButtons: false,
          paginationPosition: "bottom",
          exportButton: false,
          exportAllData: false,
          exportFileName: "Employees",
          addRowPosition: "first",
          selection: false,
          actionsColumnIndex: -1,
          grouping: false,
          columnsButton: false,
        }}
        title={""}
      /> )
      : (
      <ReviewForm setOpenReviewForm={setOpenReviewForm} currentStep={currentStage} mode={selectedReviewYear?.mode || ""}/>
      )} 
    </Box>
  );
};

const reviewData = [
  {
    title: "Review Form 2025",
    employee: "Emp1",
    status: "Manager Review",
    completedOn: "",
    currentStep: 1,
    mode: "Manager"
  },
  {
    title: "Review Form 2025",
    employee: "Emp22",
    status: "HR Review",
    completedOn: "",
    currentStep: 2,
    mode: "HR"
  },
  {
    title: "Review Form 2025",
    employee: "Emp112",
    status: "Manager Review",
    completedOn: "",
    currentStep: 2,
    mode: "Manager"
  },
  {
    title: "Review Form 2024",
    employee: "Emp2",
    status: "Manager Review",
    completedOn: "",
    currentStep: 1,
    mode: "Manager"
  },
];

export default ActionRequiredTR;
